import { render, staticRenderFns } from "./carryPeople.vue?vue&type=template&id=62ff1a19&scoped=true"
import script from "./carryPeople.vue?vue&type=script&lang=js"
export * from "./carryPeople.vue?vue&type=script&lang=js"
import style0 from "./carryPeople.vue?vue&type=style&index=0&id=62ff1a19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ff1a19",
  null
  
)

export default component.exports